export const comCopy = {
  com_layout_title: 'Ressources communautaires TypeScript',
  com_layout_description:
    "Échangez avec d'autres TypeScripters en ligne et hors ligne.",
  com_headline: 'Échangez avec nous',
  com_connect_online: 'En ligne',
  com_connect_online_description:
    'Dites nous ce qui marche, ce que vous souhaitez voir ajouté ou amélioré et restez au courant des nouvelles mises à jour.',
  com_online_stack_overflow_desc:
    "Discutez avec vos pairs et posez des questions sur TypeScript avec le tag 'typescript'",
  com_online_stack_overflow_tag: '',
  com_online_discord_header: 'Chat',
  com_online_discord_desc:
    "Discutez avec d'autres utilisateurs TypeScript dans le Chat communautaire TypeScript.",
  com_online_github_desc:
    'Vous avez trouvé un bug, ou souhaitez nous donner un commentaire constructif ?',
  com_online_github_href: 'Dites nous sur GitHub',
  com_online_twitter_desc: 'Restez à jour. Suivez-nous sur Twitter',
  com_online_blog_desc:
    'Découvrez les derniers développements TypeScript sur notre', //... blog
  com_online_typed_desc: 'Fichiers de définition TypeScript.',
  com_online_typed_href: 'Parcourez les milliers de',
  com_online_typed_available_for:
    'disponibles pour les bibliothèques et frameworks communs.',
  com_person: 'Échangez en personne',
  com_conferences: 'Conférences',
  com_conferences_alt_img: 'logo de ',
};
